module.exports = __webpack_public_path__ + "static/media/s_21.26b3d566.mp3";